import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    firstRequirement: 'Minimum 8 characters',
    secondRequirement: 'Contain uppercase and lowercase letters',
    thirdRequirement: 'Contain numbers and letters',
  },
})
